module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e3d78d21ed4c075daac30a71a31ed54c.png";